var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeautyMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#837CD6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41403 11.0161C6.58818 10.9594 5.86064 11.064 5.4256 11.152C5.17977 11.2018 5.03297 11.4377 5.09963 11.6795C5.33999 12.5513 6.08045 14.5402 8 15.5C9.47578 16.3416 11.0344 16.5 12 16.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.586 11.0161C17.4118 10.9594 18.1394 11.064 18.5744 11.152C18.8202 11.2018 18.967 11.4377 18.9004 11.6795C18.66 12.5513 17.9196 14.5402 16 15.5C14.5242 16.3416 12.9656 16.5 12 16.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.488 9.9546C9.6278 9.30991 8.74188 8.89731 8.21003 8.68209C7.94438 8.57459 7.66074 8.7339 7.61601 9.01696C7.46548 9.96957 7.29407 12.0548 8.28026 13.698C9.40718 15.5758 10.992 16.5 12 16.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.512 9.9546C14.3722 9.30991 15.2581 8.89731 15.79 8.68209C16.0556 8.57459 16.3393 8.7339 16.384 9.01696C16.5345 9.96957 16.7059 12.0548 15.7197 13.698C14.5928 15.5758 13.008 16.5 12 16.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.25C14 14.75 13 16.5 12 16.5C11 16.5 10 14.75 10 12.25C10 10.3478 11.0515 8.44393 11.6297 7.54089C11.8077 7.26271 12.1923 7.26271 12.3703 7.54089C12.9485 8.44394 14 10.3478 14 12.25Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyMarker);
export default __webpack_public_path__ + "static/media/beauty-marker.3a723f02cc234f14c6da7a4a62f408e1.svg";
export { ForwardRef as ReactComponent };